import { useMemo } from 'react'
import {
  PrimitiveTableRow,
  type PrimitiveTableRowProps,
} from '@pbt/pbt-ui-components'

import type { InventoryOrder } from '~/api/graphql/generated/types'

import { transformInventoryOrderForTable } from './utils'

interface OrdersTableRowProps extends PrimitiveTableRowProps {
  index: number
  isItemLoaded: (index: number) => boolean
  item: InventoryOrder
}

export const OrdersTableRow = ({
  item: inventoryOrderProp,
  isItemLoaded,
  index,
  data,
}: OrdersTableRowProps) => {
  const inventoryOrder = useMemo(
    () =>
      isItemLoaded(index)
        ? transformInventoryOrderForTable(inventoryOrderProp)
        : null,
    [inventoryOrderProp],
  )

  return <PrimitiveTableRow data={data} item={inventoryOrder} />
}
